/************
 * Developed by : Shiva Software Solutions
 * Date : 14-06-2021
 * Descriptions : Route for dahboard page
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const dashBoardConfigs = [
  //Redirect to dashboard page
  {
    auth: authRole.user,
    routes: [
      {
        path: '/dashboard',
        component: React.lazy(() => import('./DashboardPage/index')),
      },
    ],
  },
];
